<template>
    <div class="Layout Layout--default">
        <layout-header/>
        <div class="Layout-content">
            <slot></slot>
        </div>
        <layout-footer/>
        <toasters />
        <redirect />
    </div>
</template>

<script>
import Redirect from '../components/Redirect/Redirect.vue'
import Toasters from '../components/Toasters/Toasters.vue'
import LayoutFooter from './components/LayoutFooter.vue'
import LayoutHeader from './components/LayoutHeader.vue'

export default {
    name: 'DefaultLayout',
    components: { LayoutHeader, LayoutFooter, Redirect, Toasters }
}
</script>

<style>

</style>